/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type AnnouncementInput = {
  announcement?: string | null;
  announcementCategory?: LabelInput | null;
  announcementDate?: string | null;
  announcementLink?: string | null;
  applicationName?: LabelInput | null;
  id?: string | null;
  itemMetadata?: ItemMetadataInput | null;
  title?: string | null;
};

export type LabelInput = {
  id?: string | null;
  label?: string | null;
  labelType?: string | null;
};

export type ItemMetadataInput = {
  createdBy?: string | null;
  createdTime?: string | null;
  isActive?: boolean | null;
  updatedBy?: string | null;
  updatedTime?: string | null;
};

export type Announcement = {
  announcement?: string | null;
  announcementCategory?: Label | null;
  announcementDate?: string | null;
  announcementLink?: string | null;
  applicationName?: Label | null;
  id?: string | null;
  itemMetadata?: ItemMetadata | null;
  title?: string | null;
};

export type Label = {
  id?: string | null;
  label?: string | null;
  labelType?: string | null;
};

export type ItemMetadata = {
  createdBy?: string | null;
  createdTime?: string | null;
  isActive?: boolean | null;
  updatedBy?: string | null;
  updatedTime?: string | null;
};

export type ApplicationInput = {
  applicationIntroductionVideoUrl?: string | null;
  applicationLink?: string | null;
  applicationName?: string | null;
  applicationOwnerId?: string | null;
  embeddingEnabled?: boolean | null;
  fullApplicationDescription?: string | null;
  glAccounts?: Array<LabelInput | null> | null;
  hasAnnouncements?: boolean | null;
  hasFeedback?: boolean | null;
  hasNonProductionEnvironments?: boolean | null;
  hasTutorials?: boolean | null;
  hasWelcomeContent?: boolean | null;
  id?: string | null;
  isFlagship?: boolean | null;
  itemMetadata?: ItemMetadataInput | null;
  keyDimension?: Array<LabelInput | null> | null;
  lastEnhanced?: Array<LabelInput | null> | null;
  logoConfig?: LogoConfigInput | null;
  nonProductionEnvironments?: Array<NonProductionEnvironmentInput | null> | null;
  process?: Array<LabelInput | null> | null;
  qChatConfig?: QChatConfigInput | null;
  scenario?: Array<LabelInput | null> | null;
  shortApplicationDescription?: string | null;
  sidePanelDetails?: SidePanelDetailsInput | null;
  timeGranularity?: Array<LabelInput | null> | null;
  toolUI?: Array<LabelInput | null> | null;
  tutorialContentDetails?: Array<TutorialContentDetailsInput | null> | null;
  welcomeContentDetails?: Array<WelcomeContentDetailsInput | null> | null;
  welcomeTitle?: string | null;
};

export type LogoConfigInput = {
  logoType?: string | null;
  s3Location?: S3LocationInput | null;
  selectedLogoName?: string | null;
  uploadedFileName?: string | null;
};

export type S3LocationInput = {
  bucket?: string | null;
  contentType?: string | null;
  key?: string | null;
  region?: string | null;
};

export type NonProductionEnvironmentInput = {
  accessLevel?: Array<LabelInput | null> | null;
  displayText?: string | null;
  id?: string | null;
  link?: string | null;
};

export type QChatConfigInput = {
  agentUrl?: string | null;
  isEnabled?: boolean | null;
};

export type SidePanelDetailsInput = {
  customSidePanelWidgets?: Array<CustomSidePanelWidgetsInput | null> | null;
  keyContacts?: KeyContactsOrOfficeHoursInput | null;
  officeHours?: KeyContactsOrOfficeHoursInput | null;
  supportLinks?: CustomSidePanelWidgetsInput | null;
};

export type CustomSidePanelWidgetsInput = {
  contentType?: string | null;
  id?: string | null;
  isEnabled?: boolean | null;
  isExpandedByDefault?: boolean | null;
  richTextContent?: string | null;
  tableContent?: Array<CustomSidePanelContentEntityInput | null> | null;
  title?: string | null;
};

export type CustomSidePanelContentEntityInput = {
  displayName?: string | null;
  id?: string | null;
  link?: string | null;
  position?: number | null;
};

export type KeyContactsOrOfficeHoursInput = {
  contentType?: string | null;
  isEnabled?: boolean | null;
  isExpandedByDefault?: boolean | null;
  richTextContent?: string | null;
  title?: string | null;
};

export type TutorialContentDetailsInput = {
  category?: string | null;
  displayTitle?: string | null;
  id?: string | null;
  link?: string | null;
  position?: number | null;
};

export type WelcomeContentDetailsInput = {
  description?: string | null;
  displayText?: string | null;
  id?: string | null;
  link?: string | null;
  pointOfContact?: string | null;
};

export type Application = {
  applicationIntroductionVideoUrl?: string | null;
  applicationLink?: string | null;
  applicationName?: string | null;
  applicationOwnerId: string;
  embeddingEnabled?: boolean | null;
  fullApplicationDescription?: string | null;
  glAccounts: Array<Label | null>;
  hasAnnouncements?: boolean | null;
  hasFeedback?: boolean | null;
  hasNonProductionEnvironments?: boolean | null;
  hasTutorials?: boolean | null;
  hasWelcomeContent?: boolean | null;
  id?: string | null;
  isFlagship?: boolean | null;
  itemMetadata?: ItemMetadata | null;
  keyDimension?: Array<Label | null> | null;
  lastEnhanced?: Array<Label | null> | null;
  logoConfig?: LogoConfig | null;
  nonProductionEnvironments: Array<NonProductionEnvironment | null>;
  process?: Array<Label | null> | null;
  qChatConfig?: QChatConfig | null;
  scenario?: Array<Label | null> | null;
  shortApplicationDescription?: string | null;
  sidePanelDetails?: SidePanelDetails | null;
  timeGranularity: Array<Label | null>;
  toolUI: Array<Label | null>;
  tutorialContentDetails: Array<TutorialContentDetails | null>;
  welcomeContentDetails: Array<WelcomeContentDetails | null>;
  welcomeTitle?: string | null;
};

export type LogoConfig = {
  logoType?: string | null;
  s3Location?: S3Location | null;
  selectedLogoName?: string | null;
  uploadedFileName?: string | null;
};

export type S3Location = {
  bucket?: string | null;
  contentType?: string | null;
  key?: string | null;
  region?: string | null;
};

export type NonProductionEnvironment = {
  accessLevel?: Array<Label | null> | null;
  displayText?: string | null;
  id?: string | null;
  link?: string | null;
};

export type QChatConfig = {
  agentUrl?: string | null;
  isEnabled?: boolean | null;
};

export type SidePanelDetails = {
  customSidePanelWidgets?: Array<CustomSidePanelWidgets | null> | null;
  keyContacts?: KeyContactsOrOfficeHours | null;
  officeHours?: KeyContactsOrOfficeHours | null;
  supportLinks?: CustomSidePanelWidgets | null;
};

export type CustomSidePanelWidgets = {
  contentType?: string | null;
  id?: string | null;
  isEnabled?: boolean | null;
  isExpandedByDefault?: boolean | null;
  richTextContent?: string | null;
  tableContent?: Array<CustomSidePanelContentEntity | null> | null;
  title?: string | null;
};

export type CustomSidePanelContentEntity = {
  displayName?: string | null;
  id?: string | null;
  link?: string | null;
  position?: number | null;
};

export type KeyContactsOrOfficeHours = {
  contentType?: string | null;
  isEnabled?: boolean | null;
  isExpandedByDefault?: boolean | null;
  richTextContent?: string | null;
  title?: string | null;
};

export type TutorialContentDetails = {
  category?: string | null;
  displayTitle?: string | null;
  id?: string | null;
  link?: string | null;
  position?: number | null;
};

export type WelcomeContentDetails = {
  description?: string | null;
  displayText?: string | null;
  id?: string | null;
  link?: string | null;
  pointOfContact?: string | null;
};

export type FeedbackInput = {
  applicationName?: LabelInput | null;
  feedback?: string | null;
  feedbackType?: string | null;
  id?: string | null;
  itemMetadata?: ItemMetadataInput | null;
  rating?: number | null;
};

export type Feedback = {
  applicationName?: Label | null;
  feedback?: string | null;
  feedbackType?: string | null;
  id?: string | null;
  itemMetadata?: ItemMetadata | null;
  rating?: number | null;
};

export type GeneralContentInput = {
  content?: string | null;
  id?: string | null;
  name?: string | null;
};

export type GeneralContent = {
  content?: string | null;
  id?: string | null;
  name?: string | null;
};

export type FavoriteInput = {
  applicationId?: Array<string | null> | null;
  id?: string | null;
  userAlias?: string | null;
};

export type Favorite = {
  applicationId?: Array<string | null> | null;
  id?: string | null;
  userAlias?: string | null;
};

export type MappingInput = {
  account_id?: string | null;
  account_region?: string | null;
  app_src_type?: string | null;
  application?: string | null;
  application_name?: string | null;
  application_type?: string | null;
  aws_account_name?: string | null;
  created_at?: string | null;
  created_by?: string | null;
  cti?: string | null;
  display_sub_application_name?: string | null;
  ip_count_estimate?: string | null;
  is_active?: string | null;
  resource?: string | null;
  stage?: string | null;
  team_manager?: string | null;
  team_manager_login?: string | null;
  team_name?: string | null;
  team_poc?: string | null;
  team_poc_login?: string | null;
  updated_at?: string | null;
  updated_by?: string | null;
  vpc_cidr?: string | null;
};

export type MappingResponse = {
  numberOfRecordsUpdated?: number | null;
};

export type FinGenieActionInput = {
  context?: FinGenieContextInput | null;
  conversationId?: string | null;
  message: string;
  sessionId?: string | null;
  userId: string;
};

export type FinGenieContextInput = {
  additionalContext?: string | null;
  applicationName?: string | null;
  userRole?: string | null;
  source?: string | null;
};

export type FinGenieResponse = {
  metadata?: FinGenieMetadata | null;
  response: string;
  sessionId: string;
  status: FinGenieStatus;
  timestamp: string;
};

export type FinGenieMetadata = {
  agentAliasId?: string | null;
  agentId?: string | null;
  conversationId?: string | null;
  messageId?: string | null;
  source?: string | null;
  usage?: FinGenieUsage | null;
};

export type FinGenieUsage = {
  inputTokens?: number | null;
  outputTokens?: number | null;
  totalTokens?: number | null;
};

export enum FinGenieStatus {
  ERROR = 'ERROR',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  TIMEOUT = 'TIMEOUT'
}

export type DasFinSumFeedbackInput = {
  feedback: number;
  summaryId: string;
  userId: string;
  source?: string | null;
};

export type HomePageContentInput = {
  applicationBanner?: ApplicationBannerConfigInput | null;
  applicationIntroductionVideoUrl?: string | null;
  contactsWidgetContacts?: Array<ContactInformationInput | null> | null;
  financeCalendarEvents?: Array<FinanceCalendarEventInput | null> | null;
  fullApplicationDescription?: string | null;
  hasAnnouncements?: boolean | null;
  hasFeedback?: boolean | null;
  hasTutorials?: boolean | null;
  hasWelcomeContent?: boolean | null;
  id: string;
  itemMetadata?: ItemMetadataInput | null;
  officeHoursText?: string | null;
  sidePanelDetails?: SidePanelDetailsInput | null;
  tutorialContentDetails?: Array<TutorialContentDetailsInput | null> | null;
  welcomeContentDetails?: Array<WelcomeContentDetailsInput | null> | null;
  welcomeTitle?: string | null;
};

export type ApplicationBannerConfigInput = {
  action?: ApplicationBannerActionInput | null;
  bannerType?: string | null;
  content?: string | null;
  dismissible?: boolean | null;
  header?: string | null;
  isEnabled?: boolean | null;
};

export type ApplicationBannerActionInput = {
  label?: string | null;
  url?: string | null;
};

export type ContactInformationInput = {
  contactId?: string | null;
  groupName?: string | null;
  otherContacts?: Array<ContactDetailsInput | null> | null;
  primaryContact?: ContactDetailsInput | null;
};

export type ContactDetailsInput = {
  contactAlias?: string | null;
  contactName?: string | null;
};

export type FinanceCalendarEventInput = {
  dateTime?: string | null;
  description?: string | null;
  event?: string | null;
  eventId?: string | null;
  scenario?: string | null;
  source?: string | null;
};

export type HomePageContent = {
  applicationBanner?: ApplicationBannerConfig | null;
  applicationIntroductionVideoUrl?: string | null;
  contactsWidgetContacts?: Array<ContactInformation | null> | null;
  financeCalendarEvents?: Array<FinanceCalendarEvent | null> | null;
  fullApplicationDescription?: string | null;
  hasAnnouncements?: boolean | null;
  hasFeedback?: boolean | null;
  hasTutorials?: boolean | null;
  hasWelcomeContent?: boolean | null;
  id?: string | null;
  itemMetadata?: ItemMetadata | null;
  officeHoursText?: string | null;
  sidePanelDetails?: SidePanelDetails | null;
  tutorialContentDetails?: Array<TutorialContentDetails | null> | null;
  welcomeContentDetails?: Array<WelcomeContentDetails | null> | null;
  welcomeTitle?: string | null;
};

export type ApplicationBannerConfig = {
  action?: ApplicationBannerAction | null;
  bannerType?: string | null;
  content?: string | null;
  dismissible?: boolean | null;
  header?: string | null;
  isEnabled?: boolean | null;
};

export type ApplicationBannerAction = {
  label?: string | null;
  url?: string | null;
};

export type ContactInformation = {
  contactId?: string | null;
  groupName?: string | null;
  otherContacts?: Array<ContactDetails | null> | null;
  primaryContact?: ContactDetails | null;
};

export type ContactDetails = {
  contactAlias?: string | null;
  contactName?: string | null;
};

export type FinanceCalendarEvent = {
  dateTime?: string | null;
  description?: string | null;
  event?: string | null;
  eventId?: string | null;
  scenario?: string | null;
  source?: string | null;
};

export type TeamPageContentInput = {
  enableTeamInfoTabs?: boolean | null;
  id: string;
  itemMetadata?: ItemMetadataInput | null;
  sidePanelDetails?: SidePanelDetailsInput | null;
  teams?: Array<TeamsDetailInput | null> | null;
};

export type TeamsDetailInput = {
  id: string;
  teamIntroductionVideoUrl?: string | null;
  teamName?: string | null;
  teamOverView?: string | null;
  teamWelcomeDetails?: Array<WelcomeContentDetailsInput | null> | null;
};

export type TeamPageContent = {
  enableTeamInfoTabs?: boolean | null;
  id?: string | null;
  itemMetadata?: ItemMetadata | null;
  sidePanelDetails?: SidePanelDetails | null;
  teams?: Array<TeamsDetail | null> | null;
};

export type TeamsDetail = {
  id: string;
  teamIntroductionVideoUrl?: string | null;
  teamName?: string | null;
  teamOverView?: string | null;
  teamWelcomeDetails?: Array<WelcomeContentDetails | null> | null;
};

export type AllReportsUnderLeader = {
  reports_under_leader?: ReportsUnderLeaderList | null;
};

export type ReportsUnderLeaderList = {
  data?: Array<ReportEmployee | null> | null;
};

export type ReportEmployee = {
  department_name_current?: string | null;
  emplid?: string | null;
  employee_assistant_employee_id?: string | null;
  employee_internal_email_address?: string | null;
  employee_name?: string | null;
  job_level_name?: string | null;
  job_title_name?: string | null;
  location_city_name?: string | null;
  location_state_name?: string | null;
  login_name?: string | null;
};

export type EmployeeData = {
  department_name_current?: string | null;
  emplid?: string | null;
  employee_assistant_employee_id?: string | null;
  employee_internal_email_address?: string | null;
  employee_name?: string | null;
  job_level_name?: string | null;
  job_title_name?: string | null;
  location_city_name?: string | null;
  location_state_name?: string | null;
  login_name?: string | null;
};

export type EmployeeByAlias = {
  department_name_current?: string | null;
  emplid?: string | null;
  employee_assistant_employee_id?: string | null;
  employee_internal_email_address?: string | null;
  employee_name?: string | null;
  job_level_name?: string | null;
  job_title_name?: string | null;
  location_city_name?: string | null;
  location_state_name?: string | null;
  login_name?: string | null;
};

export type EmployeeByName = {
  department_name_current?: string | null;
  emplid?: string | null;
  employee_assistant_employee_id?: string | null;
  employee_internal_email_address?: string | null;
  employee_name?: string | null;
  job_level_name?: string | null;
  job_title_name?: string | null;
  location_city_name?: string | null;
  location_state_name?: string | null;
  login_name?: string | null;
};

export type ExecutiveAssistant = {
  department_name_current?: string | null;
  emplid?: string | null;
  employee_assistant_employee_id?: string | null;
  employee_internal_email_address?: string | null;
  employee_name?: string | null;
  job_level_name?: string | null;
  job_title_name?: string | null;
  location_city_name?: string | null;
  location_state_name?: string | null;
  login_name?: string | null;
};

export type DogmaDetails = {
  dogma_details?: DogmaDetailsList | null;
};

export type DogmaDetailsList = {
  data?: Array<DogmaDetailsData | null> | null;
  metadata?: DogmaDetailsMetadata | null;
};

export type DogmaDetailsData = {
  created_date?: string | null;
  manager_login_hierarchy_concat?: string | null;
  manager_name_hierarchy_concat?: string | null;
  resolved_date?: string | null;
  risk_best_practices?: string | null;
  risk_entity_type?: string | null;
  risk_entity_value?: string | null;
  risk_owner_login?: string | null;
  risk_owner_name?: string | null;
  risk_pipeline_name?: string | null;
  risk_rule_id?: string | null;
  risk_severity?: string | null;
  status?: string | null;
  team_name?: string | null;
};

export type DogmaDetailsMetadata = {
  last_updated_at?: string | null;
};

export type EmployeesByAliasesResponse = {
  data?: Array<EmployeeByAlias | null> | null;
};

export type EmployeesByNamesResponse = {
  data?: Array<EmployeeByName | null> | null;
};

export type ExecutiveAssistantsResponse = {
  data?: Array<ExecutiveAssistant | null> | null;
};

export type MappingColDetails = {
  col_def?: MappingColDetailsList | null;
};

export type MappingColDetailsList = {
  data?: string | null;
};

export type MappingConfig = {
  mapping_config?: MappingConfigData | null;
};

export type MappingConfigData = {
  data?: Array<MappingConfigDataDetails | null> | null;
};

export type MappingConfigDataDetails = {
  mapping_key?: string | null;
  mapping_name?: string | null;
  target_table?: string | null;
};

export type MappingDetails = {
  mapping_details?: MappingDetailsDetails | null;
};

export type MappingDetailsDetails = {
  data?: string | null;
};

export type MappingValidationConfig = {
  mapping_validation_config?: MappingValidationStr | null;
};

export type MappingValidationStr = {
  data?: string | null;
};

export type PolicyEngineDetails = {
  policy_engine_details?: PolicyEngineDetailsList | null;
};

export type PolicyEngineDetailsList = {
  data?: Array<PolicyEngineDetailsData | null> | null;
  metadata?: PolicyEngineDetailsMetadata | null;
};

export type PolicyEngineDetailsData = {
  create_date?: string | null;
  last_updated_at?: string | null;
  manager_login_hierarchy_concat?: string | null;
  manager_name_hierarchy_concat?: string | null;
  policy_class?: string | null;
  policy_type?: string | null;
  resolution_type?: string | null;
  resolved_date?: string | null;
  severity?: string | null;
  status?: string | null;
  team_name?: string | null;
  violation_entity_type?: string | null;
  violation_name?: string | null;
  violation_pretty_name?: string | null;
  violator_id?: string | null;
  violator_manager_login?: string | null;
  violator_manager_name?: string | null;
  violator_name?: string | null;
  violator_owner?: string | null;
  violator_owner_name?: string | null;
  violator_type?: string | null;
};

export type PolicyEngineDetailsMetadata = {
  last_updated_at?: string | null;
};

export type SASDetails = {
  sas_details?: SasDetailsList | null;
};

export type SasDetailsList = {
  data?: Array<SasDetailsData | null> | null;
  metadata?: SasDetailsMetadata | null;
};

export type SasDetailsData = {
  assignee_login?: string | null;
  assignee_name?: string | null;
  campaign_name?: string | null;
  has_recommendation?: string | null;
  is_blocked_campaign?: string | null;
  oldest_recommendation_age?: string | null;
  oldest_risk_age?: string | null;
  resource_name?: string | null;
  resource_type?: string | null;
  risk_status_at_eom?: string | null;
  snapshot_month?: string | null;
  supervisor_login_name_hierarchy?: string | null;
  supervisor_name_hierarchy?: string | null;
  team_name?: string | null;
};

export type SasDetailsMetadata = {
  last_updated_at?: string | null;
};

export type Testimonial = {
  announcement_id?: string | null;
  announcement_name?: string | null;
  created_at?: string | null;
  id?: string | null;
  is_active?: boolean | null;
  original_text?: string | null;
  summary?: string | null;
  testimonial_sequence?: number | null;
  updated_at?: string | null;
};

export type TicketMetricDetails = {
  ticket_details?: ticketDetailsList | null;
};

export type ticketDetailsList = {
  data?: Array<TicketMetricDetailsData | null> | null;
  metadata?: TicketDetailsMetadata | null;
};

export type TicketMetricDetailsData = {
  application_name?: string | null;
  assigned_date?: string | null;
  assigned_to_group?: string | null;
  assigned_to_individual_name?: string | null;
  assignee_login?: string | null;
  case_id?: string | null;
  create_date?: string | null;
  impact?: string | null;
  last_modified_by?: string | null;
  manager_login_hierarchy_concat?: string | null;
  manager_name_hierarchy_concat?: string | null;
  modified_date?: string | null;
  resolution_type?: string | null;
  resolved_date?: string | null;
  short_description?: string | null;
  sim_issue_alias?: string | null;
  status?: string | null;
  team_name?: string | null;
  total_time_spent?: number | null;
};

export type TicketDetailsMetadata = {
  last_updated_at?: string | null;
};

export type UserMetrics = {
  user_metrics_details?: UserMetricDetailsList | null;
};

export type UserMetricDetailsList = {
  data?: Array<UserMetricDetailsData | null> | null;
  metadata?: UserMetricDetailsMetadata | null;
};

export type UserMetricDetailsData = {
  application?: string | null;
  application_type?: string | null;
  display_sub_application_name?: string | null;
  distinct_users?: number | null;
  last_updated_at?: string | null;
  log_month?: string | null;
  measure_value?: number | null;
  supervisor_login_name_hierarchy?: string | null;
  supervisor_name_hierarchy?: string | null;
  team_name?: string | null;
};

export type UserMetricDetailsMetadata = {
  last_updated_at?: string | null;
};

export type CreateAnnouncementMutationVariables = {
  input?: AnnouncementInput | null;
};

export type CreateAnnouncementMutation = {
  createAnnouncement?: {
    announcement?: string | null;
    announcementCategory?: {
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null;
    announcementDate?: string | null;
    announcementLink?: string | null;
    applicationName?: {
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null;
    id?: string | null;
    itemMetadata?: {
      createdBy?: string | null;
      createdTime?: string | null;
      isActive?: boolean | null;
      updatedBy?: string | null;
      updatedTime?: string | null;
    } | null;
    title?: string | null;
  } | null;
};

export type CreateApplicationMutationVariables = {
  input?: ApplicationInput | null;
};

export type CreateApplicationMutation = {
  createApplication?: {
    applicationIntroductionVideoUrl?: string | null;
    applicationLink?: string | null;
    applicationName?: string | null;
    applicationOwnerId: string;
    embeddingEnabled?: boolean | null;
    fullApplicationDescription?: string | null;
    glAccounts: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null>;
    hasAnnouncements?: boolean | null;
    hasFeedback?: boolean | null;
    hasNonProductionEnvironments?: boolean | null;
    hasTutorials?: boolean | null;
    hasWelcomeContent?: boolean | null;
    id?: string | null;
    isFlagship?: boolean | null;
    itemMetadata?: {
      createdBy?: string | null;
      createdTime?: string | null;
      isActive?: boolean | null;
      updatedBy?: string | null;
      updatedTime?: string | null;
    } | null;
    keyDimension?: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null> | null;
    lastEnhanced?: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null> | null;
    logoConfig?: {
      logoType?: string | null;
      s3Location?: {
        bucket?: string | null;
        contentType?: string | null;
        key?: string | null;
        region?: string | null;
      } | null;
      selectedLogoName?: string | null;
      uploadedFileName?: string | null;
    } | null;
    nonProductionEnvironments: Array<{
      accessLevel?: Array<{
        id?: string | null;
        label?: string | null;
        labelType?: string | null;
      } | null> | null;
      displayText?: string | null;
      id?: string | null;
      link?: string | null;
    } | null>;
    process?: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null> | null;
    qChatConfig?: {
      agentUrl?: string | null;
      isEnabled?: boolean | null;
    } | null;
    scenario?: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null> | null;
    shortApplicationDescription?: string | null;
    sidePanelDetails?: {
      customSidePanelWidgets?: Array<{
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null> | null;
      keyContacts?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      officeHours?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      supportLinks?: {
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null;
    } | null;
    timeGranularity: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null>;
    toolUI: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null>;
    tutorialContentDetails: Array<{
      category?: string | null;
      displayTitle?: string | null;
      id?: string | null;
      link?: string | null;
      position?: number | null;
    } | null>;
    welcomeContentDetails: Array<{
      description?: string | null;
      displayText?: string | null;
      id?: string | null;
      link?: string | null;
      pointOfContact?: string | null;
    } | null>;
    welcomeTitle?: string | null;
  } | null;
};

export type CreateFeedbackMutationVariables = {
  input?: FeedbackInput | null;
};

export type CreateFeedbackMutation = {
  createFeedback?: {
    applicationName?: {
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null;
    feedback?: string | null;
    feedbackType?: string | null;
    id?: string | null;
    itemMetadata?: {
      createdBy?: string | null;
      createdTime?: string | null;
      isActive?: boolean | null;
      updatedBy?: string | null;
      updatedTime?: string | null;
    } | null;
    rating?: number | null;
  } | null;
};

export type CreateGeneralContentMutationVariables = {
  input?: GeneralContentInput | null;
};

export type CreateGeneralContentMutation = {
  createGeneralContent?: {
    content?: string | null;
    id?: string | null;
    name?: string | null;
  } | null;
};

export type CreateOrUpdateApplicationFavoritesMutationVariables = {
  input?: FavoriteInput | null;
};

export type CreateOrUpdateApplicationFavoritesMutation = {
  createOrUpdateApplicationFavorites?: {
    applicationId?: Array<string | null> | null;
    id?: string | null;
    userAlias?: string | null;
  } | null;
};

export type CreateOrUpdateLabelsMutationVariables = {
  input?: Array<LabelInput | null> | null;
};

export type CreateOrUpdateLabelsMutation = {
  createOrUpdateLabels?: {
    id?: string | null;
    label?: string | null;
    labelType?: string | null;
  } | null;
};

export type CreateOrUpdateMappingMutationVariables = {
  input?: Array<MappingInput | null> | null;
  table_name?: string | null;
};

export type CreateOrUpdateMappingMutation = {
  createOrUpdateMapping?: {
    numberOfRecordsUpdated?: number | null;
  } | null;
};

export type DeleteApplicationMutationVariables = {
  input?: Array<ApplicationInput | null> | null;
};

export type DeleteApplicationMutation = {
  deleteApplication?: Array<string | null> | null;
};

export type FingenieActionMutationVariables = {
  input: FinGenieActionInput;
};

export type FingenieActionMutation = {
  fingenieAction?: {
    metadata?: {
      agentAliasId?: string | null;
      agentId?: string | null;
      conversationId?: string | null;
      messageId?: string | null;
      source?: string | null;
      usage?: {
        inputTokens?: number | null;
        outputTokens?: number | null;
        totalTokens?: number | null;
      } | null;
    } | null;
    response: string;
    sessionId: string;
    status: FinGenieStatus;
    timestamp: string;
  } | null;
};

export type UpdateAnnouncementMutationVariables = {
  input?: AnnouncementInput | null;
};

export type UpdateAnnouncementMutation = {
  updateAnnouncement?: {
    announcement?: string | null;
    announcementCategory?: {
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null;
    announcementDate?: string | null;
    announcementLink?: string | null;
    applicationName?: {
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null;
    id?: string | null;
    itemMetadata?: {
      createdBy?: string | null;
      createdTime?: string | null;
      isActive?: boolean | null;
      updatedBy?: string | null;
      updatedTime?: string | null;
    } | null;
    title?: string | null;
  } | null;
};

export type UpdateApplicationMutationVariables = {
  input?: ApplicationInput | null;
};

export type UpdateApplicationMutation = {
  updateApplication?: {
    applicationIntroductionVideoUrl?: string | null;
    applicationLink?: string | null;
    applicationName?: string | null;
    applicationOwnerId: string;
    embeddingEnabled?: boolean | null;
    fullApplicationDescription?: string | null;
    glAccounts: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null>;
    hasAnnouncements?: boolean | null;
    hasFeedback?: boolean | null;
    hasNonProductionEnvironments?: boolean | null;
    hasTutorials?: boolean | null;
    hasWelcomeContent?: boolean | null;
    id?: string | null;
    isFlagship?: boolean | null;
    itemMetadata?: {
      createdBy?: string | null;
      createdTime?: string | null;
      isActive?: boolean | null;
      updatedBy?: string | null;
      updatedTime?: string | null;
    } | null;
    keyDimension?: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null> | null;
    lastEnhanced?: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null> | null;
    logoConfig?: {
      logoType?: string | null;
      s3Location?: {
        bucket?: string | null;
        contentType?: string | null;
        key?: string | null;
        region?: string | null;
      } | null;
      selectedLogoName?: string | null;
      uploadedFileName?: string | null;
    } | null;
    nonProductionEnvironments: Array<{
      accessLevel?: Array<{
        id?: string | null;
        label?: string | null;
        labelType?: string | null;
      } | null> | null;
      displayText?: string | null;
      id?: string | null;
      link?: string | null;
    } | null>;
    process?: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null> | null;
    qChatConfig?: {
      agentUrl?: string | null;
      isEnabled?: boolean | null;
    } | null;
    scenario?: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null> | null;
    shortApplicationDescription?: string | null;
    sidePanelDetails?: {
      customSidePanelWidgets?: Array<{
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null> | null;
      keyContacts?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      officeHours?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      supportLinks?: {
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null;
    } | null;
    timeGranularity: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null>;
    toolUI: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null>;
    tutorialContentDetails: Array<{
      category?: string | null;
      displayTitle?: string | null;
      id?: string | null;
      link?: string | null;
      position?: number | null;
    } | null>;
    welcomeContentDetails: Array<{
      description?: string | null;
      displayText?: string | null;
      id?: string | null;
      link?: string | null;
      pointOfContact?: string | null;
    } | null>;
    welcomeTitle?: string | null;
  } | null;
};

export type UpdateDasFinSumFeedbackMutationVariables = {
  input?: DasFinSumFeedbackInput | null;
};

export type UpdateDasFinSumFeedbackMutation = {
  updateDasFinSumFeedback?: boolean | null;
};

export type UpdateFeedbackMutationVariables = {
  input?: FeedbackInput | null;
};

export type UpdateFeedbackMutation = {
  updateFeedback?: {
    applicationName?: {
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null;
    feedback?: string | null;
    feedbackType?: string | null;
    id?: string | null;
    itemMetadata?: {
      createdBy?: string | null;
      createdTime?: string | null;
      isActive?: boolean | null;
      updatedBy?: string | null;
      updatedTime?: string | null;
    } | null;
    rating?: number | null;
  } | null;
};

export type UpdateGeneralContentMutationVariables = {
  input?: Array<GeneralContentInput | null> | null;
};

export type UpdateGeneralContentMutation = {
  updateGeneralContent?: Array<{
    content?: string | null;
    id?: string | null;
    name?: string | null;
  } | null> | null;
};

export type UpdateHomePageContentMutationVariables = {
  input?: HomePageContentInput | null;
};

export type UpdateHomePageContentMutation = {
  updateHomePageContent?: {
    applicationBanner?: {
      action?: {
        label?: string | null;
        url?: string | null;
      } | null;
      bannerType?: string | null;
      content?: string | null;
      dismissible?: boolean | null;
      header?: string | null;
      isEnabled?: boolean | null;
    } | null;
    applicationIntroductionVideoUrl?: string | null;
    contactsWidgetContacts?: Array<{
      contactId?: string | null;
      groupName?: string | null;
      otherContacts?: Array<{
        contactAlias?: string | null;
        contactName?: string | null;
      } | null> | null;
      primaryContact?: {
        contactAlias?: string | null;
        contactName?: string | null;
      } | null;
    } | null> | null;
    financeCalendarEvents?: Array<{
      dateTime?: string | null;
      description?: string | null;
      event?: string | null;
      eventId?: string | null;
      scenario?: string | null;
      source?: string | null;
    } | null> | null;
    fullApplicationDescription?: string | null;
    hasAnnouncements?: boolean | null;
    hasFeedback?: boolean | null;
    hasTutorials?: boolean | null;
    hasWelcomeContent?: boolean | null;
    id?: string | null;
    itemMetadata?: {
      createdBy?: string | null;
      createdTime?: string | null;
      isActive?: boolean | null;
      updatedBy?: string | null;
      updatedTime?: string | null;
    } | null;
    officeHoursText?: string | null;
    sidePanelDetails?: {
      customSidePanelWidgets?: Array<{
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null> | null;
      keyContacts?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      officeHours?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      supportLinks?: {
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null;
    } | null;
    tutorialContentDetails?: Array<{
      category?: string | null;
      displayTitle?: string | null;
      id?: string | null;
      link?: string | null;
      position?: number | null;
    } | null> | null;
    welcomeContentDetails?: Array<{
      description?: string | null;
      displayText?: string | null;
      id?: string | null;
      link?: string | null;
      pointOfContact?: string | null;
    } | null> | null;
    welcomeTitle?: string | null;
  } | null;
};

export type UpdateTeamPageContentMutationVariables = {
  input?: TeamPageContentInput | null;
};

export type UpdateTeamPageContentMutation = {
  updateTeamPageContent?: {
    enableTeamInfoTabs?: boolean | null;
    id?: string | null;
    itemMetadata?: {
      createdBy?: string | null;
      createdTime?: string | null;
      isActive?: boolean | null;
      updatedBy?: string | null;
      updatedTime?: string | null;
    } | null;
    sidePanelDetails?: {
      customSidePanelWidgets?: Array<{
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null> | null;
      keyContacts?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      officeHours?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      supportLinks?: {
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null;
    } | null;
    teams?: Array<{
      id: string;
      teamIntroductionVideoUrl?: string | null;
      teamName?: string | null;
      teamOverView?: string | null;
      teamWelcomeDetails?: Array<{
        description?: string | null;
        displayText?: string | null;
        id?: string | null;
        link?: string | null;
        pointOfContact?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ListAllReportsUnderLeaderQueryVariables = {
  hierarchy_distance?: number | null;
  supervisor_login: string;
};

export type ListAllReportsUnderLeaderQuery = {
  listAllReportsUnderLeader?: {
    reports_under_leader?: {
      data?: Array<{
        department_name_current?: string | null;
        emplid?: string | null;
        employee_assistant_employee_id?: string | null;
        employee_internal_email_address?: string | null;
        employee_name?: string | null;
        job_level_name?: string | null;
        job_title_name?: string | null;
        location_city_name?: string | null;
        location_state_name?: string | null;
        login_name?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type ListAnnouncementsQueryVariables = {};

export type ListAnnouncementsQuery = {
  listAnnouncements?: Array<{
    announcement?: string | null;
    announcementCategory?: {
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null;
    announcementDate?: string | null;
    announcementLink?: string | null;
    applicationName?: {
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null;
    id?: string | null;
    itemMetadata?: {
      createdBy?: string | null;
      createdTime?: string | null;
      isActive?: boolean | null;
      updatedBy?: string | null;
      updatedTime?: string | null;
    } | null;
    title?: string | null;
  } | null> | null;
};

export type ListApplicationFavoritesQueryVariables = {
  userAlias?: string | null;
};

export type ListApplicationFavoritesQuery = {
  listApplicationFavorites?: Array<{
    applicationId?: Array<string | null> | null;
    id?: string | null;
    userAlias?: string | null;
  } | null> | null;
};

export type ListApplicationsQueryVariables = {};

export type ListApplicationsQuery = {
  listApplications?: Array<{
    applicationIntroductionVideoUrl?: string | null;
    applicationLink?: string | null;
    applicationName?: string | null;
    applicationOwnerId: string;
    embeddingEnabled?: boolean | null;
    fullApplicationDescription?: string | null;
    glAccounts: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null>;
    hasAnnouncements?: boolean | null;
    hasFeedback?: boolean | null;
    hasNonProductionEnvironments?: boolean | null;
    hasTutorials?: boolean | null;
    hasWelcomeContent?: boolean | null;
    id?: string | null;
    isFlagship?: boolean | null;
    itemMetadata?: {
      createdBy?: string | null;
      createdTime?: string | null;
      isActive?: boolean | null;
      updatedBy?: string | null;
      updatedTime?: string | null;
    } | null;
    keyDimension?: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null> | null;
    lastEnhanced?: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null> | null;
    logoConfig?: {
      logoType?: string | null;
      s3Location?: {
        bucket?: string | null;
        contentType?: string | null;
        key?: string | null;
        region?: string | null;
      } | null;
      selectedLogoName?: string | null;
      uploadedFileName?: string | null;
    } | null;
    nonProductionEnvironments: Array<{
      accessLevel?: Array<{
        id?: string | null;
        label?: string | null;
        labelType?: string | null;
      } | null> | null;
      displayText?: string | null;
      id?: string | null;
      link?: string | null;
    } | null>;
    process?: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null> | null;
    qChatConfig?: {
      agentUrl?: string | null;
      isEnabled?: boolean | null;
    } | null;
    scenario?: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null> | null;
    shortApplicationDescription?: string | null;
    sidePanelDetails?: {
      customSidePanelWidgets?: Array<{
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null> | null;
      keyContacts?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      officeHours?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      supportLinks?: {
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null;
    } | null;
    timeGranularity: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null>;
    toolUI: Array<{
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null>;
    tutorialContentDetails: Array<{
      category?: string | null;
      displayTitle?: string | null;
      id?: string | null;
      link?: string | null;
      position?: number | null;
    } | null>;
    welcomeContentDetails: Array<{
      description?: string | null;
      displayText?: string | null;
      id?: string | null;
      link?: string | null;
      pointOfContact?: string | null;
    } | null>;
    welcomeTitle?: string | null;
  } | null> | null;
};

export type ListDogmaDetailQueryVariables = {};

export type ListDogmaDetailQuery = {
  listDogmaDetail?: {
    dogma_details?: {
      data?: Array<{
        created_date?: string | null;
        manager_login_hierarchy_concat?: string | null;
        manager_name_hierarchy_concat?: string | null;
        resolved_date?: string | null;
        risk_best_practices?: string | null;
        risk_entity_type?: string | null;
        risk_entity_value?: string | null;
        risk_owner_login?: string | null;
        risk_owner_name?: string | null;
        risk_pipeline_name?: string | null;
        risk_rule_id?: string | null;
        risk_severity?: string | null;
        status?: string | null;
        team_name?: string | null;
      } | null> | null;
      metadata?: {
        last_updated_at?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ListEmployeesByAliasesQueryVariables = {
  login_aliases: Array<string | null>;
};

export type ListEmployeesByAliasesQuery = {
  listEmployeesByAliases?: {
    data?: Array<{
      department_name_current?: string | null;
      emplid?: string | null;
      employee_assistant_employee_id?: string | null;
      employee_internal_email_address?: string | null;
      employee_name?: string | null;
      job_level_name?: string | null;
      job_title_name?: string | null;
      location_city_name?: string | null;
      location_state_name?: string | null;
      login_name?: string | null;
    } | null> | null;
  } | null;
};

export type ListEmployeesByNamesQueryVariables = {
  employee_names: Array<string | null>;
  records_per_name?: number | null;
};

export type ListEmployeesByNamesQuery = {
  listEmployeesByNames?: {
    data?: Array<{
      department_name_current?: string | null;
      emplid?: string | null;
      employee_assistant_employee_id?: string | null;
      employee_internal_email_address?: string | null;
      employee_name?: string | null;
      job_level_name?: string | null;
      job_title_name?: string | null;
      location_city_name?: string | null;
      location_state_name?: string | null;
      login_name?: string | null;
    } | null> | null;
  } | null;
};

export type ListExecutiveAssistantsQueryVariables = {
  supervisor_login?: string | null;
};

export type ListExecutiveAssistantsQuery = {
  listExecutiveAssistants?: {
    data?: Array<{
      department_name_current?: string | null;
      emplid?: string | null;
      employee_assistant_employee_id?: string | null;
      employee_internal_email_address?: string | null;
      employee_name?: string | null;
      job_level_name?: string | null;
      job_title_name?: string | null;
      location_city_name?: string | null;
      location_state_name?: string | null;
      login_name?: string | null;
    } | null> | null;
  } | null;
};

export type ListFeedbackQueryVariables = {};

export type ListFeedbackQuery = {
  listFeedback?: Array<{
    applicationName?: {
      id?: string | null;
      label?: string | null;
      labelType?: string | null;
    } | null;
    feedback?: string | null;
    feedbackType?: string | null;
    id?: string | null;
    itemMetadata?: {
      createdBy?: string | null;
      createdTime?: string | null;
      isActive?: boolean | null;
      updatedBy?: string | null;
      updatedTime?: string | null;
    } | null;
    rating?: number | null;
  } | null> | null;
};

export type ListGeneralContentQueryVariables = {};

export type ListGeneralContentQuery = {
  listGeneralContent?: Array<{
    content?: string | null;
    id?: string | null;
    name?: string | null;
  } | null> | null;
};

export type ListHomePageContentQueryVariables = {};

export type ListHomePageContentQuery = {
  listHomePageContent?: {
    applicationBanner?: {
      action?: {
        label?: string | null;
        url?: string | null;
      } | null;
      bannerType?: string | null;
      content?: string | null;
      dismissible?: boolean | null;
      header?: string | null;
      isEnabled?: boolean | null;
    } | null;
    applicationIntroductionVideoUrl?: string | null;
    contactsWidgetContacts?: Array<{
      contactId?: string | null;
      groupName?: string | null;
      otherContacts?: Array<{
        contactAlias?: string | null;
        contactName?: string | null;
      } | null> | null;
      primaryContact?: {
        contactAlias?: string | null;
        contactName?: string | null;
      } | null;
    } | null> | null;
    financeCalendarEvents?: Array<{
      dateTime?: string | null;
      description?: string | null;
      event?: string | null;
      eventId?: string | null;
      scenario?: string | null;
      source?: string | null;
    } | null> | null;
    fullApplicationDescription?: string | null;
    hasAnnouncements?: boolean | null;
    hasFeedback?: boolean | null;
    hasTutorials?: boolean | null;
    hasWelcomeContent?: boolean | null;
    id?: string | null;
    itemMetadata?: {
      createdBy?: string | null;
      createdTime?: string | null;
      isActive?: boolean | null;
      updatedBy?: string | null;
      updatedTime?: string | null;
    } | null;
    officeHoursText?: string | null;
    sidePanelDetails?: {
      customSidePanelWidgets?: Array<{
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null> | null;
      keyContacts?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      officeHours?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      supportLinks?: {
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null;
    } | null;
    tutorialContentDetails?: Array<{
      category?: string | null;
      displayTitle?: string | null;
      id?: string | null;
      link?: string | null;
      position?: number | null;
    } | null> | null;
    welcomeContentDetails?: Array<{
      description?: string | null;
      displayText?: string | null;
      id?: string | null;
      link?: string | null;
      pointOfContact?: string | null;
    } | null> | null;
    welcomeTitle?: string | null;
  } | null;
};

export type ListLabelsQueryVariables = {};

export type ListLabelsQuery = {
  listLabels?: Array<{
    id?: string | null;
    label?: string | null;
    labelType?: string | null;
  } | null> | null;
};

export type ListMappingColDetailsQueryVariables = {};

export type ListMappingColDetailsQuery = {
  listMappingColDetails?: {
    col_def?: {
      data?: string | null;
    } | null;
  } | null;
};

export type ListMappingConfigQueryVariables = {};

export type ListMappingConfigQuery = {
  listMappingConfig?: {
    mapping_config?: {
      data?: Array<{
        mapping_key?: string | null;
        mapping_name?: string | null;
        target_table?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type ListMappingDetailsQueryVariables = {
  table_name?: string | null;
};

export type ListMappingDetailsQuery = {
  listMappingDetails?: {
    mapping_details?: {
      data?: string | null;
    } | null;
  } | null;
};

export type ListMappingValidationConfigQueryVariables = {};

export type ListMappingValidationConfigQuery = {
  listMappingValidationConfig?: {
    mapping_validation_config?: {
      data?: string | null;
    } | null;
  } | null;
};

export type ListPolicyEngineDetailQueryVariables = {};

export type ListPolicyEngineDetailQuery = {
  listPolicyEngineDetail?: {
    policy_engine_details?: {
      data?: Array<{
        create_date?: string | null;
        last_updated_at?: string | null;
        manager_login_hierarchy_concat?: string | null;
        manager_name_hierarchy_concat?: string | null;
        policy_class?: string | null;
        policy_type?: string | null;
        resolution_type?: string | null;
        resolved_date?: string | null;
        severity?: string | null;
        status?: string | null;
        team_name?: string | null;
        violation_entity_type?: string | null;
        violation_name?: string | null;
        violation_pretty_name?: string | null;
        violator_id?: string | null;
        violator_manager_login?: string | null;
        violator_manager_name?: string | null;
        violator_name?: string | null;
        violator_owner?: string | null;
        violator_owner_name?: string | null;
        violator_type?: string | null;
      } | null> | null;
      metadata?: {
        last_updated_at?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ListSASDetailQueryVariables = {};

export type ListSASDetailQuery = {
  listSASDetail?: {
    sas_details?: {
      data?: Array<{
        assignee_login?: string | null;
        assignee_name?: string | null;
        campaign_name?: string | null;
        has_recommendation?: string | null;
        is_blocked_campaign?: string | null;
        oldest_recommendation_age?: string | null;
        oldest_risk_age?: string | null;
        resource_name?: string | null;
        resource_type?: string | null;
        risk_status_at_eom?: string | null;
        snapshot_month?: string | null;
        supervisor_login_name_hierarchy?: string | null;
        supervisor_name_hierarchy?: string | null;
        team_name?: string | null;
      } | null> | null;
      metadata?: {
        last_updated_at?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ListTeamPageContentQueryVariables = {};

export type ListTeamPageContentQuery = {
  listTeamPageContent?: {
    enableTeamInfoTabs?: boolean | null;
    id?: string | null;
    itemMetadata?: {
      createdBy?: string | null;
      createdTime?: string | null;
      isActive?: boolean | null;
      updatedBy?: string | null;
      updatedTime?: string | null;
    } | null;
    sidePanelDetails?: {
      customSidePanelWidgets?: Array<{
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null> | null;
      keyContacts?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      officeHours?: {
        contentType?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        title?: string | null;
      } | null;
      supportLinks?: {
        contentType?: string | null;
        id?: string | null;
        isEnabled?: boolean | null;
        isExpandedByDefault?: boolean | null;
        richTextContent?: string | null;
        tableContent?: Array<{
          displayName?: string | null;
          id?: string | null;
          link?: string | null;
          position?: number | null;
        } | null> | null;
        title?: string | null;
      } | null;
    } | null;
    teams?: Array<{
      id: string;
      teamIntroductionVideoUrl?: string | null;
      teamName?: string | null;
      teamOverView?: string | null;
      teamWelcomeDetails?: Array<{
        description?: string | null;
        displayText?: string | null;
        id?: string | null;
        link?: string | null;
        pointOfContact?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ListTestimonialsQueryVariables = {};

export type ListTestimonialsQuery = {
  listTestimonials?: Array<{
    announcement_id?: string | null;
    announcement_name?: string | null;
    created_at?: string | null;
    id?: string | null;
    is_active?: boolean | null;
    original_text?: string | null;
    summary?: string | null;
    testimonial_sequence?: number | null;
    updated_at?: string | null;
  } | null> | null;
};

export type ListTicketMetricDetailQueryVariables = {};

export type ListTicketMetricDetailQuery = {
  listTicketMetricDetail?: {
    ticket_details?: {
      data?: Array<{
        application_name?: string | null;
        assigned_date?: string | null;
        assigned_to_group?: string | null;
        assigned_to_individual_name?: string | null;
        assignee_login?: string | null;
        case_id?: string | null;
        create_date?: string | null;
        impact?: string | null;
        last_modified_by?: string | null;
        manager_login_hierarchy_concat?: string | null;
        manager_name_hierarchy_concat?: string | null;
        modified_date?: string | null;
        resolution_type?: string | null;
        resolved_date?: string | null;
        short_description?: string | null;
        sim_issue_alias?: string | null;
        status?: string | null;
        team_name?: string | null;
        total_time_spent?: number | null;
      } | null> | null;
      metadata?: {
        last_updated_at?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ListUserMetricQueryVariables = {};

export type ListUserMetricQuery = {
  listUserMetric?: {
    user_metrics_details?: {
      data?: Array<{
        application?: string | null;
        application_type?: string | null;
        display_sub_application_name?: string | null;
        distinct_users?: number | null;
        last_updated_at?: string | null;
        log_month?: string | null;
        measure_value?: number | null;
        supervisor_login_name_hierarchy?: string | null;
        supervisor_name_hierarchy?: string | null;
        team_name?: string | null;
      } | null> | null;
      metadata?: {
        last_updated_at?: string | null;
      } | null;
    } | null;
  } | null;
};

export type OnFinGenieResponseSubscriptionVariables = {
  sessionId: string;
};

export type OnFinGenieResponseSubscription = {
  onFinGenieResponse?: {
    metadata?: {
      agentAliasId?: string | null;
      agentId?: string | null;
      conversationId?: string | null;
      messageId?: string | null;
      source?: string | null;
      usage?: {
        inputTokens?: number | null;
        outputTokens?: number | null;
        totalTokens?: number | null;
      } | null;
    } | null;
    response: string;
    sessionId: string;
    status: FinGenieStatus;
    timestamp: string;
  } | null;
};
